"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Module = exports.npmURIBase = void 0;
const models_1 = require("lincd/lib/models");
const Shape_1 = require("lincd/lib/shapes/Shape");
const dc_1 = require("lincd-dcmi/lib/ontologies/dc");
const npm_1 = require("../ontologies/npm");
const package_1 = require("../package");
const ShapeDecorators_1 = require("lincd/lib/utils/ShapeDecorators");
const ModuleDependency_1 = require("./ModuleDependency");
const schema_1 = require("lincd-schema/lib/ontologies/schema");
const Person_1 = require("lincd-foaf/lib/shapes/Person");
exports.npmURIBase = 'https://www.npmjs.com/package/';
let Module = class Module extends Shape_1.Shape {
    get author() {
        return this.hasProperty(npm_1.npm.author) ? new Person_1.Person(this.getOne(npm_1.npm.author)) : null;
    }
    set author(val) {
        this.overwrite(npm_1.npm.author, val.namedNode);
    }
    get description() {
        return this.getValue(dc_1.dcelems.description);
    }
    set description(val) {
        this.overwrite(dc_1.dcelems.description, new models_1.Literal(val));
    }
    // Don't set a max count..
    // (TODO) this way we can have a history of published dates
    get datePublished() {
        return this.getValue(schema_1.schema.datePublished);
    }
    set datePublished(val) {
        this.overwrite(schema_1.schema.datePublished, new models_1.Literal(val));
    }
    get version() {
        return this.getValue(npm_1.npm.version);
    }
    set version(val) {
        this.overwrite(npm_1.npm.version, new models_1.Literal(val));
    }
    get packageName() {
        return this.getValue(npm_1.npm.packageName);
    }
    set packageName(val) {
        this.overwrite(npm_1.npm.packageName, new models_1.Literal(val));
    }
    get repository() {
        return this.getValue(npm_1.npm.repository);
    }
    set repository(val) {
        this.overwrite(npm_1.npm.repository, new models_1.Literal(val));
    }
    get repositoryFullURL() {
        let url = this.repository;
        let match;
        if (!url.includes('http://') && !url.includes('https://')) {
            if (url.includes('git+')) {
                url = url.replace('git+', '');
            }
            //for git:user/repo or user/repo or gitlab:user/repo
            else if ((match = url.match(/(\w+:)?([a-z0-9-._~]+)\/([a-z0-9-._~]+)/))) {
                let [, type, user, repo] = match;
                if (type) {
                    type = type.replace(':', '');
                }
                if (!type) {
                    type = 'github';
                }
                url = `https://${type}.com/${user}/${repo}.git`;
            }
            else {
                console.warn('Unknown type of repository url: ' + url);
            }
        }
        return url;
    }
    addDependency(dependency) {
        this.set(npm_1.npm.dependency, dependency instanceof ModuleDependency_1.ModuleDependency ? dependency.node : dependency);
    }
    getDependencies() {
        return ModuleDependency_1.ModuleDependency.getSetOf(this.getAll(npm_1.npm.dependency));
    }
    addDependencyFromProperties(packageName, version) {
        let dependency = ModuleDependency_1.ModuleDependency.getFromURI(this.namedNode.uri + '/dependency/' + packageName + '/' + version);
        dependency.packageName = packageName;
        dependency.version = version;
        this.addDependency(dependency);
        return dependency;
    }
    static getNPMModuleURI(packageName, versionNumber) {
        return exports.npmURIBase + packageName + (versionNumber ? '/v/' + versionNumber : '');
    }
};
Module.targetClass = npm_1.npm.Module;
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: npm_1.npm.author,
        required: true,
        maxCount: 1,
    })
], Module.prototype, "author", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: dc_1.dcelems.description,
        required: false,
        maxCount: 1,
    })
], Module.prototype, "description", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: schema_1.schema.datePublished,
        required: false,
    })
], Module.prototype, "datePublished", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: npm_1.npm.version,
        required: true,
        maxCount: 1,
    })
], Module.prototype, "version", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: npm_1.npm.packageName,
        required: true,
        maxCount: 1,
    })
], Module.prototype, "packageName", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: npm_1.npm.repository,
        required: false,
        maxCount: 1,
    })
], Module.prototype, "repository", null);
Module = __decorate([
    package_1.linkedShape
], Module);
exports.Module = Module;
//# sourceMappingURL=Module.js.map